// extracted by mini-css-extract-plugin
export default {"item___selected":"FancyMenuItem_item___selected__dxRRn"};